<script>
import mixin from '@/plans/mx/shopping-cart';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
export default {
  mixins: [mixin],
  components: {
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  methods: {
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.mx_title(
              this.$t('billing.cmr.title'),
              <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>,
            )}
            {this.mx_discount(plan.plan_code)}
            {this.mx_license(plan.cartCapacity, plan.cartCapacityUnit)}
            {this.mx_cycle(plan.billing_cycle)}
            <AltProratedPlanPeriod type={plan.type} />
            {this.mx_edit(plan)}
            {this.mx_remove(plan)}
          </div>
        );
      });
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
